import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DefaultStyles from '../../../constants/DefaultFormStyles';

const StyledWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledBlock = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.backgroundColor || DefaultStyles.backgroundColor};
  font-size:${(props) => (props.fontSize !== undefined ? `${props.fontSize}px` : DefaultStyles.fontSize)} !important;
  color: ${(props) => props.fontColor || DefaultStyles.fontColor};
  font-style: ${(props) => props.fontStyle || 'normal'};
  font-weight: ${(props) => props.fontWeight || 'normal'};
  text-align: ${(props) => props.textAlign || 'left'};
  text-transform: ${(props) => props.textTransform || 'none'};
  text-decoration: ${(props) => props.textDecoration || 'none'};
  ${(props) => (props.textOverflow ? `text-overflow: ${props.textOverflow};` : '')}
  overflow: ${(props) => (props.textOverflow ? 'hidden;' : 'visible;')}
  border-radius: ${(props) => (props.borderRadius !== undefined ? `${props.borderRadius}px` : DefaultStyles.borderRadius)};
  border: ${(props) => props.border};
  padding: ${(props) => (props.padding !== undefined ? `${props.padding}px` : DefaultStyles.padding)};
  resize: none;
`;

/**
 * Why didn't I use a functional component here?
 *
 * The unmount functionality with the useEffect doesn't allow me
 * to access the focused and changes state that I needed. Inside
 * of the useEffect cleanup it always showed both these values
 * as undefined.
 *
 */
class BlockField extends React.PureComponent {

  static propTypes = {

    fieldPositionId: PropTypes.string,

    value: PropTypes.string,
    disabled: PropTypes.bool,

    //Field style
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderRadius: PropTypes.number,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,
  }

  static defaultProps = {
    value: ''
  }

  render() {

    const {
      fieldPositionId,
      disabled,
      value,

      //Field style
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderRadius,
      borderWidth,
      backgroundColor,
      padding,
    } = this.props;

    /**
     * We join width and color to a single border style because chrome displays
     * the border as a two tone color if you use border-color and border-width
     * indvidually.
     */
    const bWidth = borderWidth !== undefined ? `${borderWidth}px` : DefaultStyles.borderWidth;
    const bColor = borderColor || 'transparent';
    const border = `${bWidth} solid ${bColor}`;

    return (
      <StyledWrapper>
        <StyledBlock
          data-testid={`${fieldPositionId}-block-field`}
          border={border}
          {...{
            disabled,

            fontSize,
            fontColor,
            fontStyle,
            fontWeight,
            textAlign,
            textTransform,
            textDecoration,
            textOverflow,
            borderColor,
            borderRadius,
            borderWidth,
            backgroundColor,
            padding,
          }}
        >
          {value}
        </StyledBlock>
      </StyledWrapper>
    );
  }
}

export default BlockField;
